import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20cozy%20illustration%20of%20a%20reading%20corner%20with%20soft%20blankets%20and%20warm%20golden%20lamp%20light%2C%20books%20and%20manga%20volumes%20stacked%2C%20abstract%20artistic%20style%2C%20cream%20and%20amber%20tones%2C%20dreamy%20peaceful%20atmosphere%2C%20no%20text&width=1600&height=600&seq=cta-bg-manga-02&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-secondary-900/70 to-secondary-900/40" />
      <div className="relative max-w-[1280px] mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-4xl text-background-50">
          随时随地，畅享漫画乐趣
        </h2>
        <p className="mt-3 text-sm md:text-base text-background-50/80 max-w-lg mx-auto">
          布丁漫画网为您提供最流畅的在线阅读体验，下拉式连续阅读，无需翻页，沉浸式享受每一话的精彩内容。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-8">
          <Link
            to="/comic/dongdong-zahuopu"
            className="px-8 py-3.5 bg-primary-500 text-background-50 dark:text-foreground-950 text-base font-medium rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            立即免费阅读
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 text-base font-medium rounded-full hover:bg-background-50/25 transition-all whitespace-nowrap cursor-pointer border border-background-50/25"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}